import InvoiceController from '../invoices/InvoiceController';
import { PaymentLinksDataGrid } from './management/PaymentLinksDataGrid';

export function PaymentLinksScreen() {
  return (
    <>
      <PaymentLinksDataGrid />
      <InvoiceController />
    </>
  );
}
